import { HttpClient } from '@angular/common/http';
import { DOCUMENT, Inject, Injectable } from '@angular/core';
import { AppConfigurationService } from '@safarilaw-webapp/shared/environment';
import * as appconfigurationCi from '../../appconfiguration/appconfiguration.ci.json';
import * as appconfigurationDemo from '../../appconfiguration/appconfiguration.demo.json';
import * as appconfigurationDev from '../../appconfiguration/appconfiguration.json';
import * as appconfigurationPrd from '../../appconfiguration/appconfiguration.prd.json';
import * as appconfigurationQa from '../../appconfiguration/appconfiguration.qa.json';

@Injectable()
export class LpmsConfigurationService extends AppConfigurationService {
  constructor(httpClient: HttpClient, @Inject(DOCUMENT) document: Document) {
    super(httpClient, document);
  }
  injectConfiguration() {
    this._injectedAppConfig = super.getCorrectEnvironment([
      appconfigurationDev.default as unknown as AppConfigurationService,
      appconfigurationCi.default as unknown as AppConfigurationService,
      appconfigurationQa.default as unknown as AppConfigurationService,
      appconfigurationDemo.default as unknown as AppConfigurationService,
      appconfigurationPrd.default as unknown as AppConfigurationService
    ]);
  }
  getConfiguration() {
    return super.getCorrectEnvironment([
      appconfigurationDev.default as unknown as AppConfigurationService,
      appconfigurationCi.default as unknown as AppConfigurationService,
      appconfigurationQa.default as unknown as AppConfigurationService,
      appconfigurationDemo.default as unknown as AppConfigurationService,
      appconfigurationPrd.default as unknown as AppConfigurationService
    ]);
  }
}
